import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import type { CreateDatabaseFormValues } from '@/routes/databases/create-database/form/schema'

export const Name = () => {
  const form = useFormContext<CreateDatabaseFormValues>()
  const { resetField } = form

  useEffect(() => {
    return () => {
      resetField('displayName')
    }
  }, [resetField])

  return (
    <FormField
      control={form.control}
      name="displayName"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Display name</FormLabel>
          <FormControl>
            <Input
              autoComplete="off"
              placeholder="My database name"
              aria-label="Display name"
              {...field}
            />
          </FormControl>
          <FormMessage />
          <FormDescription>
            This name helps you identify your database in the Sevalla dashboard
          </FormDescription>
        </FormItem>
      )}
    />
  )
}
